import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import styled from 'styled-components';
import { LinearProgress } from '@beeline.com/bp-design-system';
import { LoadingEvent, LoadingEventType } from 'src/utils/hooks/useSystemLoading';
import { TopBar } from './TopBar';
import { useCallback } from 'react';
import { AuthUser } from 'src/providers/User/AuthUserModels';

interface Props {
  user: AuthUser;
  onHelpClick: () => void;
  isHelpOpen: boolean;
  onBriefingClick: () => void;
}

const Header: FC<PropsWithChildren<Props>> = ({ user, onHelpClick, isHelpOpen, onBriefingClick }) => {
  const [isSystemLoading, setSystemLoading] = useState(false);

  const onLoadingEvent = useCallback((event: Event) => {
    if (event.type === LoadingEventType) {
      setSystemLoading((event as CustomEvent<LoadingEvent>).detail.isLoading);
    }
  }, []);

  useEffect(() => {
    document.addEventListener(LoadingEventType, onLoadingEvent);

    // cleanup this component
    return () => {
      document.removeEventListener(LoadingEventType, onLoadingEvent);
    };
  }, [onLoadingEvent]);

  return (
    <StyledHeaderContainer>
      <TopBar user={user} isHelpOpen={isHelpOpen} onHelpClick={onHelpClick} onBriefingClick={onBriefingClick} />
      <div className="loading-container">
        {isSystemLoading && <LinearProgress dataTest="loading-header" className="loading" />}
      </div>
    </StyledHeaderContainer>
  );
};

const StyledHeaderContainer = styled.div`
  background-color: ${({ theme }) => theme.colorSurface};
  border-bottom: 1px solid ${({ theme }) => theme.colorSurfaceVariant};
  .loading-container {
    width: 100%;
    height: 0px;
    position: relative;
    background-color: ${({ theme }) => theme.colorSurface};
    z-index: 1;
  }
`;

export default Header;
